/**
 * Persists which characterization-2 alerts have already been shown in this session.
 * Each alert is shown only once until the user authenticates again (login clears this).
 */

const STORAGE_KEY = "char2_alerts_shown";

function getStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function setStored(obj) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch {
    // ignore
  }
}

export function getChar2AlertShown(alertId) {
  return Boolean(getStored()[alertId]);
}

export function setChar2AlertShown(alertId) {
  const next = { ...getStored(), [alertId]: true };
  setStored(next);
}

/**
 * Call this when the user logs in so alerts will show again for the new session.
 */
export function clearChar2AlertsShown() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Stable alert ids for characterization-2 (use these when calling get/setChar2AlertShown). */
export const CHAR2_ALERT_IDS = {
  DANGER_WASTE: "char2_alert_danger_waste",
  REGULATION_MAIN: "char2_alert_regulation_main",
  REGULATION_1199_SORTING: "char2_alert_regulation_1199_sorting",
  INFO_NON_COMPLIANT: "char2_alert_info_non_compliant",
};
